import React from 'react';

class AdditionalQuestion extends React.Component{
    render(){
        return(
            <div className="questionSecondHeading additional" dangerouslySetInnerHTML={{__html: this.props.frageTitle}}>
            </div>
        );
}
}
export default AdditionalQuestion
